'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
var defaults = {
  title: null,
  description: null,
  logoUrl: null,
  useCompanyLogo: false,
  showWelcomeScreen: false
};

var WelcomeScreenInfo = /*#__PURE__*/function (_Record) {
  _inherits(WelcomeScreenInfo, _Record);

  function WelcomeScreenInfo() {
    _classCallCheck(this, WelcomeScreenInfo);

    return _possibleConstructorReturn(this, _getPrototypeOf(WelcomeScreenInfo).apply(this, arguments));
  }

  _createClass(WelcomeScreenInfo, null, [{
    key: "from",
    value: function from(json) {
      return new WelcomeScreenInfo(json);
    }
  }]);

  return WelcomeScreenInfo;
}(Record(defaults));

export { WelcomeScreenInfo as default };